var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:("width: 100%; height: 100%; min-height: 500px; max-height: 800px; min-width: 200px; margin-bottom: 2px"),attrs:{"id":_vm.id,"name":_vm.nome}})}
var staticRenderFns = []

export { render, staticRenderFns }